import { render, staticRenderFns } from "./yuFaJingJiang.vue?vue&type=template&id=6939f36b&scoped=true&"
import script from "./yuFaJingJiang.vue?vue&type=script&lang=js&"
export * from "./yuFaJingJiang.vue?vue&type=script&lang=js&"
import style0 from "./yuFaJingJiang.vue?vue&type=style&index=0&id=6939f36b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6939f36b",
  null
  
)

export default component.exports